import React, { useRef, useReducer, useEffect, useState, useCallback } from 'react'
import {
    Grid, TextField, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Button, Dialog, DialogContent, IconButton, Accordion, AccordionSummary, AccordionDetails, Select, FormControl, MenuItem, Snackbar
} from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import CloseIcon from '@material-ui/icons/Close'
import { DataGrid } from '@mui/x-data-grid';
import { useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress'
import { mainStyleClasses } from '../../theme'
import { mqttConfig } from '../../config/mqttConfig'
import { mqttClient } from '../../config/mqttClient'
import { functionPublish } from '../../config/functionPublish'
import { dataDescriptions } from './data/dataDescriptions'
import { dataRange } from './data/dataRange'
import { FileUpload } from '../../components'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { TimeModeRegister } from './components'

//dane DataGrid, czyli tabelka do wyświetlania
const registerListReducer = (state, action, setEditTime) => {
    let stateHelpAdd = { ...state }
    let data = action.payload
    let registers = []
    let timeModes = []

    // console.log({ data })
    let index = 0
    switch (action.reg) {
        case "broker":
            data.map((device, ind) => (
                Object.keys(device.data).sort().map((register, i) => {
                    let reg = {}
                    reg.id = index
                    reg.registerName = register
                    reg.value = dataRange()[register] ? `${device.data[register]}${dataRange()[register].symbol}` : device.data[register]
                    reg.device = device.name
                    reg.device_type = device.type
                    reg.device_version = device.version

                    index = index + 1

                    return registers.push(reg)
                })
            ))

            data.map((device, ind) => {
                if (device.TIME_MODES) {
                    return device.TIME_MODES.map((register, i) => {
                        // console.log({ register })
                        let reg = {}
                        reg.id = index
                        reg.index = i
                        reg.registerName = register.TIME_NAME
                        // reg.value = dataRange()[register] ? `${device.data[register]}${dataRange()[register].symbol}` : device.data[register]
                        // reg.def_value = register.DEFAULT_VAL
                        reg.intervals = register.INTERVALS

                        register.INTERVALS.map((interval, i) => {
                            reg.intervals[i].id = i
                            reg.intervals[i].registerName = register.TIME_NAME
                            reg.intervals[i].device = device.name
                            reg.intervals[i].device_type = device.type
                            reg.intervals[i].device_version = device.version
                            reg.intervals[i].START = interval.START.toString()
                            reg.intervals[i].STOP = interval.STOP.toString()
                            reg.intervals[i].VALUE = interval.VALUE
                            reg.intervals[i].modeId = reg.index

                            // console.log({ interval })
                        })

                        reg.device = device.name
                        reg.device_type = device.type
                        reg.device_version = device.version

                        index = index + 1

                        // console.log({ device })
                        // console.log({ register })
                        return timeModes.push(reg)
                    })
                } else {
                    return null
                }
            })
            break;

        case "editTime":
            let stateHelp = { ...state }
            console.log(action.payload.row)
            // console.log(action.payload.payload.target.name)
            // console.log(action.payload.payload.target.value)
            // console.log(stateHelp.timeModes[action.payload.row.modeId].intervals[action.payload.row.id][action.payload.payload.target.name])

            stateHelp.timeModes[action.payload.row.modeId].intervals[action.payload.row.id][action.payload.payload.target.name] = action.payload.payload.target.value
            // console.log({ stateHelp })
            setEditTime(stateHelp.timeModes)
            return stateHelp


        case "addTimeInterval":

            console.log({ payload: data })

            stateHelpAdd.timeModes[data[0].modeId].intervals = data

            return stateHelpAdd
        default:
            break;
    }
    // data.map((device, ind) => (
    //     Object.keys(device.data).sort().map((register, i) => {
    //         let reg = {}
    //         reg.id = index
    //         reg.registerName = register
    //         reg.value = dataRange()[register] ? `${device.data[register]}${dataRange()[register].symbol}` : device.data[register]
    //         reg.device = device.name
    //         reg.device_type = device.type
    //         reg.device_version = device.version

    //         index = index + 1

    //         return registers.push(reg)
    //     })
    // ))

    // data.map((device, ind) => {
    //     if (device.TIME_MODES) {
    //         return device.TIME_MODES.map((register, i) => {
    //             let reg = {}
    //             reg.id = index
    //             reg.registerName = register.NAME
    //             // reg.value = dataRange()[register] ? `${device.data[register]}${dataRange()[register].symbol}` : device.data[register]
    //             // reg.def_value = register.DEFAULT_VAL
    //             reg.intervals = register.INTERVALS

    //             register.INTERVALS.map((interval, i) => {
    //                 reg.intervals[i].id = i
    //                 reg.intervals[i].nameMode = register.NAME
    //                 reg.intervals[i].device = device.name
    //                 reg.intervals[i].device_type = device.type
    //                 reg.intervals[i].device_version = device.version
    //                 reg.intervals[i].START = interval.START.toString()
    //                 reg.intervals[i].STOP = interval.STOP.toString()
    //                 reg.intervals[i].VALUE = interval.VALUE

    //                 console.log({ interval })
    //             })

    //             reg.device = device.name
    //             reg.device_type = device.type
    //             reg.device_version = device.version

    //             index = index + 1

    //             // console.log({ device })
    //             // console.log({ register })
    //             return timeModes.push(reg)
    //         })
    //     } else {
    //         return null
    //     }
    // })
    console.log({ registers, timeModes, data: action.payload })

    return { registers, timeModes }
}

const weekArray = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"]

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
  }

const RegisterList = () => {
    let { installation, pass } = useParams()
    const [connectMess, setConnectMess] = useState(0)
    const clientRef = useRef(null)
    const classes = mainStyleClasses()
    const [messages, setMessages] = useState(null)
    const [connectionStatus, setConnectionStatus] = useState(false)
    const [registers, setRegisters] = useReducer(registerListReducer, [])
    const [editRegs, setEditRegs] = useState({})
    const [editDevices, setEditDevices] = useState({})
    const [editNames, setEditNames] = useState([])
    const [editTime, setEditTime] = useState(null)
    const [open, setOpen] = useState(false)
    const [errorOfExpiration, seterrorOfExpiration] = useState(null)
    const [pageSize, setPageSize] = useState(50)
    const [openFileUpload, setOpenFileUpload] = useState(false)
    const [openSnack, setOpenSnack] = useState({status: false, msg: ""})



  const handleClick = (txt) => {
    setOpenSnack({status: true, msg: txt})
  }

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpenSnack({status: false, msg: ""})
  }

    sessionStorage.setItem('deviceName', messages ? messages[0].Name : null)
    sessionStorage.setItem('version', messages ? `${messages[0].VER_S1}.${messages[0].VER_S2}` : null)

    const handleClickOpen = (dialog) => {
        if (dialog === 'saveChanges') {
            setOpen(true)
        } else if (dialog === 'upload') {
            setOpenFileUpload(true)
        }
    }

    const handleClose = () => {
        setOpen(false)
        setOpenFileUpload(false)
    }

    const handleClickEdit = (names, devices) => {
        let uniqueDevices = [...new Set(Object.values(devices).map(item => item.name))]

        let dataAll = []
        let deviceAll = []

        uniqueDevices.map((Device, i) => {
            let deviceNames = names.filter(name => devices[name].name === Device)
            let data = {}
            deviceNames.forEach(name => {
                data[name] = editRegs[name]
            })

            let device = {
                Name: Device,
                Type: devices[deviceNames[0]].type,
                Version: devices[deviceNames[0]].version,
            }

            dataAll.push(data)
            deviceAll.push(device)
        })

        if (messages && messages[0]) {
            console.log(dataAll)
            functionPublish(clientRef.current, dataAll, installation, deviceAll)
        }

        setEditNames([])
        setEditDevices({})
        setOpen(false)
    }

    const handleDelete = (name) => {
        let result = editNames.filter(item => item !== name)
        setEditNames(result)

        let result2 = editDevices
        delete result2[name]
        setEditDevices(result2)
    }

    // const [columns, setColumns] = useState([
    const t_mode_columns = [
        // { field: 'registerName', headerName: 'Interwał', width: 200, headerClassName: 'user-table-header' },
        // {
        //     field: 'START',
        //     headerName: 'Start',
        //     width: 150,
        //     headerClassName: 'user-table-header',
        //     filterable: false,
        //     editable: true
        //     // renderCell: (params) => {
        //     //     return <TextField name={'START'} type="number" step={"any"}
        //     //         onChange={(e) => onChangeInputTime(e, params.row)}
        //     //         value={params.row.START ? params.row.START : 0} />;
        //     // }
        // },
        {
            field: 'START', headerName: 'Wartość START', width: 200, headerClassName: 'user-table-header', filterable: false,
            renderCell: (params) => {
                return <div style={{ lineHeight: "1" }}>
                    <div style={{ marginBottom: "15px" }}>{params.row.START} minut<br /></div>
                    <div>{`${weekArray[parseInt(params.row.START / 1440)]}, ${parseInt((params.row.START % 1440) / 60)} : ${parseInt((params.row.START % 1440) % 60)}`}</div>
                </div>
            }
        },
        {
            field: 'START-value',
            headerName: 'Start',
            width: 350,
            headerClassName: 'user-table-header',
            filterable: false,
            renderCell: (params) => {
                return <div style={{ lineHeight: "1", width: "100%" }}>
                    <div style={{ marginBottom: "15px" }}>
                        <TextField name="START" type="number" step={"any"}
                            onChange={(e) => onChangeInputTime(e, params.row, "minOnly")}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].START : params.row.START} /><br />
                    </div>
                    <div>
                        <FormControl style={{ width: "150px", float: "left", marginRight: "30px" }}>
                            <Select
                                style={{ width: "100%" }}
                                labelId="dayWeek"
                                name="START"
                                id="dayWeekParams"
                                value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                    parseInt(editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].START / 1440)
                                    : parseInt(params.row.START / 1440)}
                                onChange={(e) => onChangeInputTime(e, params.row, "dayInput")}
                            >
                                {weekArray.map((item, index) => {
                                    return <MenuItem key={item + index} value={index}> {item} </MenuItem>
                                })
                                }
                            </Select>
                        </FormControl>
                        <TextField style={{ width: "70px", float: "left" }} name="START" type="number" step={1}
                            onChange={(e) => onChangeInputTime(e, params.row, "hourInput")}
                            inputProps={{
                                min: 0,
                                max: 23,
                                maxlength: 2
                            }}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                parseInt((editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].START % 1440) / 60) : parseInt((params.row.START % 1440) / 60)} />
                        <TextField style={{ width: "70px", float: "left" }} name="START" type="number" step={1}
                            onChange={(e) => onChangeInputTime(e, params.row, "minInput")}
                            inputProps={{
                                min: 0,
                                max: 60,
                                maxlength: 2
                            }}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                parseInt((editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].START % 1440) % 60) : parseInt((params.row.START % 1440) % 60)} /><br />
                    </div>
                </div>
            }
        },
        {
            field: 'STOP', headerName: 'Wartość STOP', width: 200, headerClassName: 'user-table-header', filterable: false,
            renderCell: (params) => {
                return <div style={{ lineHeight: "1" }}>
                    <div style={{ marginBottom: "15px" }}>{params.row.STOP} minut<br /></div>
                    <div>{`${weekArray[parseInt(params.row.STOP / 1440)]}, ${parseInt((params.row.STOP % 1440) / 60)} : ${parseInt((params.row.STOP % 1440) % 60)}`}</div>
                </div>
            }
        },
        {
            field: 'STOP-value',
            headerName: 'Stop',
            width: 350,
            headerClassName: 'user-table-header',
            filterable: false,
            renderCell: (params) => {
                return <div style={{ lineHeight: "1", width: "100%" }}>
                    <div style={{ marginBottom: "15px" }}>
                        <TextField name="STOP" type="number" step={"any"}
                            onChange={(e) => onChangeInputTime(e, params.row, "minOnly")}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].STOP : params.row.STOP} /><br />
                    </div>
                    <div>
                        <FormControl style={{ width: "150px", float: "left", marginRight: "30px" }}>
                            <Select
                                style={{ width: "100%" }}
                                labelId="dayWeek"
                                name="STOP"
                                id="dayWeekParams"
                                value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                    parseInt(editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].STOP / 1440)
                                    : parseInt(params.row.STOP / 1440)}
                                onChange={(e) => onChangeInputTime(e, params.row, "dayInput")}
                            >
                                {weekArray.map((item, index) => {
                                    return <MenuItem key={item + index} value={index}> {item} </MenuItem>
                                })
                                }
                            </Select>
                        </FormControl>
                        <TextField style={{ width: "70px", float: "left" }} name="STOP" type="number" step={1}
                            onChange={(e) => onChangeInputTime(e, params.row, "hourInput")}
                            inputProps={{
                                min: 0,
                                max: 23,
                                maxlength: 2
                            }}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                parseInt((editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].STOP % 1440) / 60) : parseInt((params.row.STOP % 1440) / 60)} />
                        <TextField style={{ width: "70px", float: "left" }} name="STOP" type="number" step={1}
                            onChange={(e) => onChangeInputTime(e, params.row, "minInput")}
                            inputProps={{
                                min: 0,
                                max: 60,
                                maxlength: 2
                            }}
                            value={editTime[params.row.device] && editTime[params.row.device][params.row.modeId] && editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id] ?
                                parseInt((editTime[params.row.device][params.row.modeId].INTERVALS[params.row.id].STOP % 1440) % 60) : parseInt((params.row.STOP % 1440) % 60)} /><br />
                    </div>
                </div>
            }
        },
        { field: 'VALUE', headerName: 'Wartość', width: 150, headerClassName: 'user-table-header', filterable: false },
        {
            field: 'Button', headerName: 'Usuń', flex: 1, headerClassName: 'user-table-header', filterable: false, editable: true,
            renderCell: (params) => {
                return <Button variant="contained" color="primary" onClick={() => publishTimeData(params.row, "deleteTimeModeInterval")} style={{ marginTop: '30px', float: "right" }}>Usuń interwał</Button>;
            }
        }
    ]
    const columns = [
        { field: 'registerName', headerName: 'Nazwa rejestru', width: 200, headerClassName: 'user-table-header' },
        { field: 'device', headerName: 'Sterownik', width: 150, headerClassName: 'user-table-header' },
        // { field: 'device_type', headerName: 'Typ sterownika', width: 150, headerClassName: 'user-table-header', hide: true },
        // { field: 'device_version', headerName: 'Wersja sterownika', width: 150, headerClassName: 'user-table-header', hide: true },
        {
            field: "description",
            headerName: "Opis",
            headerClassName: 'user-table-header',
            cellClassName: 'desc-styling',
            flex: 1,
            filterable: false,
            // hide: false,
            renderCell: params => <Typography variant='body1'>{!dataDescriptions() ? "" : dataDescriptions()[params.row.registerName] ? (dataDescriptions()[params.row.registerName] === "NA" ? "" : dataDescriptions()[params.row.registerName]) : ""}</Typography>
        },
        { field: 'value', headerName: 'Aktualna wartość', width: 250, headerClassName: 'user-table-header', filterable: false },
        {
            field: "range",
            headerName: "Zakres",
            headerClassName: 'user-table-header',
            cellClassName: 'desc-styling',
            width: 130,
            filterable: false,
            renderCell: (params) => (
                dataRange()[params.row.registerName] && (dataRange()[params.row.registerName].min || dataRange()[params.row.registerName].max) ? (
                    <div>
                        <span className='data-grid-min'>{`Min: ${dataRange()[params.row.registerName].min ? dataRange()[params.row.registerName].min : (dataRange()[params.row.registerName].min === 0 ? "0" : "-")}`}</span>
                        <span>{`Max: ${dataRange()[params.row.registerName].max ? dataRange()[params.row.registerName].max : (dataRange()[params.row.registerName].max === 0 ? "0" : "-")}`}</span>
                    </div>
                ) : ""
            )
        },
        {
            field: "edit",
            headerName: "Edytuj wartość",
            sortable: false,
            headerClassName: 'user-table-header',
            flex: 1,
            filterable: false,
            renderCell: (params) => {
                return <TextField name={params.row.registerName} type="number" step={"any"}
                    onChange={(e) => onChangeInput(e, params.row.device, params.row.device_type, params.row.device_version)}
                    value={editRegs[params.row.registerName] ? editRegs[params.row.registerName] : ""} />;
            }
        },
    ]
    // ])

    const onChangeInput = (e, device, device_type, device_version) => {
        let names = editNames

        if (!names.includes(e.target.name)) {
            names.push(e.target.name)
            setEditNames(names)
        }

        setEditRegs({ ...editRegs, [e.target.name]: e.target.value })
        setEditDevices({ ...editDevices, [e.target.name]: { name: device, type: device_type, version: device_version } })
    }

    const publishTimeData = (params, action) => {
        let editTimeHelp = editTime ? { ...editTime } : { ...registers.timeModes }
        let intervalsPublish
        let intervalArray = []

        if (action === "addTimeModeInterval")
            intervalArray = editTimeHelp[params.device][params.intervals[0].modeId].INTERVALS.map(item => item)

        switch (action) {
            case "editTimeModeInterval":
                intervalsPublish = editTime[params.device][params.intervals[0].modeId].INTERVALS.map((interval, index) => {
                    return { START: interval.START, STOP: interval.STOP, VALUE: interval.VALUE }
                })
                handleClick(`Edytowano interwał trybu: ${params.registerName}`)
                break;

            case "deleteTimeModeInterval":
                // console.log({ params })
                let intervalsNotDeleteFilter = editTime[params.device][params.modeId].INTERVALS.filter((interval, index) => interval.id !== params.id)
                intervalsPublish = intervalsNotDeleteFilter.map((interval, index) => {
                    return { START: interval.START, STOP: interval.STOP, VALUE: interval.VALUE }
                })
                editTimeHelp[params.device][params.modeId].INTERVALS = intervalsNotDeleteFilter
                // console.log({ intervalsNotDeleteFilter })
                // console.log({ intervalsPublish })
                // console.log({ editTimeHelp })
                // console.log({ editTime })
                setEditTime(editTimeHelp)
                handleClick(`Usunięto interwał z trybu: ${params.registerName}`)
                break;

            case "addTimeModeInterval":
                // console.log({ params })
                // console.log({ editTimeHelp })
                let newInterval = { START: "0", STOP: "0", VALUE: "1", device: params.device, device_type: params.device_type, device_version: params.device_version, id: editTimeHelp[params.device][params.intervals[0].modeId].INTERVALS && editTimeHelp[params.device][params.intervals[0].modeId].INTERVALS.length > 0 ? editTimeHelp[params.device][params.intervals[0].modeId].INTERVALS.length : 0, modeId: params.intervals[0].modeId, registerName: params.registerName }

                intervalArray.push(newInterval)
                // console.log(intervalArray)
                editTimeHelp[params.device][params.intervals[0].modeId].INTERVALS = intervalArray
                setEditTime(editTimeHelp)
                // console.log({ editTimeHelp })
                intervalsPublish = intervalArray.map((interval, index) => {
                    return { START: interval.START, STOP: interval.STOP, VALUE: interval.VALUE }
                })
                handleClick(`Dodano nowy interwał do trybu: ${params.registerName}`)
                // setRegisters({ payload: intervalArray, reg: "addTimeInterval" })
                break;
            default:
                break;
        }
        // console.log({ intervalsPublish })
        let deviceData = { Name: params.device, Type: params.device_type, Version: params.device_version }
        let data = [{ DEFAULT_VAL: 0, INTERVALS: intervalsPublish, TIME_NAME: params.registerName }]

        functionPublish(clientRef.current, {}, installation, deviceData, null, null, data)
    }

    const onChangeInputTime = (payload, row, action) => {

        let stateHelp = { ...editTime }

        switch (action) {
            case "minOnly":
                stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name] = payload.target.value
                break;
            case "dayInput":
                // console.log("dayInput")
                let dayInputHelp = editTime[row.device] ?
                    parseInt(editTime[row.device][row.modeId].INTERVALS[row.id][payload.target.name] / 1440) : parseInt(row[payload.target.name] / 1440)
                let dayMinMax = parseInt(payload.target.value) ? parseInt(payload.target.value) >= 6 ? 6 : parseInt(payload.target.value) : 0
                stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name] = dayInputHelp === 0 ? parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) + (dayMinMax * 1440) : (parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) - (dayInputHelp * 1440)) + (dayMinMax * 1440)
                break;
            case "hourInput":
                // console.log("hourInput")
                let hourInputHelp = editTime[row.device] ?
                    parseInt((editTime[row.device][row.modeId].INTERVALS[row.id][payload.target.name] % 1440) / 60) : parseInt((row[payload.target.name] % 1440) / 60)
                let hourMinMax = parseInt(payload.target.value) ? parseInt(payload.target.value) >= 24 ? 23 : parseInt(payload.target.value) : 0
                stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name] = hourInputHelp === 0 ? parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) + (hourMinMax * 60) : (parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) - (hourInputHelp * 60)) + (hourMinMax * 60)
                break;
            case "minInput":
                // console.log("minInput")
                let minInputHelp = editTime[row.device] ?
                    parseInt((editTime[row.device][row.modeId].INTERVALS[row.id][payload.target.name] % 1440) % 60) : parseInt((row[payload.target.name] % 1440) % 60)
                let minMinMax = parseInt(payload.target.value) ? parseInt(payload.target.value) >= 60 ? 59 : parseInt(payload.target.value) : 0
                stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name] = minInputHelp === 0 ? parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) + minMinMax : (parseInt(stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name]) - minInputHelp) + minMinMax
                break;
            default:
                stateHelp[row.device][row.modeId].INTERVALS[row.id][payload.target.name] = payload.target.value
                break;
        }

        setEditTime(stateHelp)
    }


    useEffect(() => {
        clientRef.current = mqttClient.getClient(mqttConfig())
        clientRef.current.subscribe(`${installation}/Dev`)
        clientRef.current.on('connect', () => setConnectionStatus(true))
        clientRef.current.on('message', function (topic, message, packet) {

            if (topic === `${installation}/Dev` && JSON.parse(message)) {
                let DateTime = new Date()
                let StampTime = new Date()
                DateTime = Date.now()

                StampTime = Date.parse(JSON.parse(message).TimeStamp)
                if (DateTime - StampTime > JSON.parse(message).ExpirationTime + 3000) {
                    seterrorOfExpiration(1)
                } else {
                    seterrorOfExpiration(null)
                }
                let saveToState = JSON.parse(message).Devices
                saveToState.expirationData = {
                    ExpirationTime: JSON.parse(message).ExpirationTime,
                    TimeStamp: JSON.parse(message).TimeStamp
                }

                setMessages(saveToState)
                console.log(JSON.parse(message))
                let deviceTimeModes = {}
                let extdata = JSON.parse(message).Devices.map((device, i) => {
                    if (device.TIME_MODES) {
                        deviceTimeModes[device.Name] = device.TIME_MODES
                    }
                    return { name: device.Name, data: device.Data, type: device.Type, version: device.Version, TIME_MODES: device.TIME_MODES ? device.TIME_MODES : null }
                })
                // console.log({deviceTimeModes})
                if (!editTime || editTime === {})
                    setEditTime(deviceTimeModes)
                // console.log({ deviceTimeModes })
                setRegisters({ payload: extdata, reg: "broker" })
            }
        })

        return () => {
            if (clientRef.current) {
                clientRef.current.unsubscribe(`${installation}/Dev`)
                clientRef.current.end(clientRef.current)
            }
        }

    }, [installation, editTime])

    const startedAppData = (statusStart) => {
        if (statusStart === 0) {
            setConnectMess(1)
            let extdata = messages.map((device, i) => {
                return device.Data
            })
            let flatten = {}
            for (let i = 0; i < extdata.length; i++) {
                Object.assign(flatten, extdata[i]);
            }

            setEditRegs(flatten)
        }
    }

    const handleSaveRegistries = () => {
        const data = JSON.stringify(messages, null, "\t");
        const myBlob = new Blob(
            [data],
            { type: "text/plain" }
        );

        const url = URL.createObjectURL(myBlob);
        const link = document.createElement('a');
        link.download = `${installation}_${new Date().getFullYear()}.${new Date().getMonth() + 1 < 10 ? 0 + (new Date().getMonth() + 1).toString() : new Date().getMonth() + 1}.${new Date().getDate() < 10 ? new Date().getDate().toString() : new Date().getDate()}.json`;
        link.href = url;
        link.click();
    }

    useEffect(() => {
        let mounted = true
        if (messages)
            startedAppData(connectMess)

        return () => {
            mounted = false
        }
    }, [connectMess, messages])

    return (
        <React.Fragment>
            <Grid container style={{ position: "sticky", zIndex: 99, backgroundColor: 'white', top: 0 }}>
                <Grid item xs={2} style={{ padding: 0 }}>
                    <Typography variant="h2">Lista rejestrów</Typography>
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
                    <Button variant="contained" color="primary"
                        onClick={handleSaveRegistries} >
                        Zapisz konfigurację
                    </Button>
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
                    <Button variant="contained" color="primary"
                        onClick={() => handleClickOpen('upload')} >
                        Załaduj konfigurację
                    </Button>
                </Grid>
            </Grid>
            {registers && registers.registers ? (<Grid container>
                <Grid item xs={12} style={{ marginTop: 30 }}>
                    <DataGrid
                        columns={columns}
                        rows={registers.registers}
                        autoHeight
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[10, 30, 50, 100]}
                        pagination
                    />
                </Grid>
            </Grid>) : <CircularProgress />}
            {registers && registers.timeModes ? <React.Fragment>
                <Grid container>
                    <Grid item xs={12} style={{ marginTop: 30 }}>
                        <Typography variant='h2'>Tryby czasowe</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} style={{ marginTop: 30 }}>
                        <TimeModeRegister />
                    </Grid>
                </Grid>
                {registers.timeModes.map((t_mode, index) => (
                    <Accordion key={t_mode.registerName + index}>

                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant='h2' style={{ textAlign: 'left !important', marginLeft: 0 }}>Interwały trybu czasowego ({t_mode.device}): <span style={{ textTransform: 'uppercase' }}>{t_mode.registerName}</span></Typography>
                                </Grid>

                            </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                <Grid item xs={12}>
                                    <DataGrid
                                        // editMode="row"
                                        columns={t_mode_columns}
                                        rows={t_mode.intervals}
                                        // editRowsModel={t_mode.intervals}
                                        // onEditRowsModelChange={(e) => onChangeInputTime(e)}
                                        autoHeight
                                        rowHeight={100}
                                        pageSize={pageSize}
                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                        rowsPerPageOptions={[10, 30, 50, 100]}
                                        pagination
                                        aria-label="TRYBY CZASOWE"
                                    /></Grid>
                                <Grid item xs={6}>
                                    <Button variant="contained" color="primary" onClick={() => publishTimeData(t_mode, "addTimeModeInterval")} style={{ marginTop: '30px', float: "left" }}>Dodaj interwał do trybu {t_mode.registerName}</Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button variant="contained" color="primary" onClick={() => publishTimeData(t_mode, "editTimeModeInterval")} style={{ marginTop: '30px', float: "right" }}>Zatwierdź Tryb {t_mode.registerName}</Button>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>

                )
                )}
                <Snackbar open={openSnack.status} autoHideDuration={6000} onClose={handleCloseSnack}>
                    <Alert onClose={handleCloseSnack} severity="success">
                        {openSnack.msg}
                    </Alert>
                </Snackbar>
                {/*<Grid container>
                    <Grid item xs={12}>
                        <DataGrid
                            columns={columns}
                            rows={registers.timeModes}
                            autoHeight
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[10, 30, 50, 100]}
                            pagination
                            aria-label="tryby"
                        />
                    </Grid>
                </Grid>*/}
            </React.Fragment> : <CircularProgress />}
            <Button variant="contained" color="primary" style={{ position: "fixed", right: "5%", bottom: "5%", zIndex: 99 }}
                onClick={() => handleClickOpen('saveChanges')} >
                Zatwierdź zmiany
            </Button>
            <Dialog scroll={"body"} fullWidth={true} maxWidth={"md"} open={open} onClose={handleClose} aria-labelledby="edit-registers">
                <DialogContent style={{ padding: "10px 25px 25px" }}>
                    <IconButton aria-label="close" onClick={handleClose} className={classes.floatRight} style={{ zIndex: "99", position: "absolute", top: "10px", right: "15px" }}>
                        <CloseIcon />
                    </IconButton>
                    <Grid container direction="row" >
                        <Grid item xs={12}>
                            <Typography variant="h2">Lista zmian</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Typography component="div" height="100%">
                                                    <Box fontWeight="fontWeightBold" height="100%">
                                                        <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item xs={12} style={{ padding: '0' }}>
                                                                Nazwa rejestru
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography component="div" height="100%">
                                                    <Box fontWeight="fontWeightBold" height="100%">
                                                        <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item xs={12} style={{ padding: '0' }}>
                                                                Sterownik
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography component="div" height="100%">
                                                    <Box fontWeight="fontWeightBold" height="100%">
                                                        <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item xs={12} style={{ padding: '0' }}>
                                                                Obecna wartość
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography component="div">
                                                    <Box fontWeight="fontWeightBold">
                                                        <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item xs={12} style={{ padding: '0' }}>
                                                                Wartość wprowadzona
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography component="div">
                                                    <Box fontWeight="fontWeightBold">
                                                        <Grid container spacing={0} direction="row" justifyContent="center" alignItems="center">
                                                            <Grid item xs={12} style={{ padding: '0' }}>
                                                                Usuń zmianę
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {editNames && editNames.length > 0 ? (
                                            editNames.map((name, id) => (
                                                <TableRow key={id}>
                                                    <TableCell>{name}</TableCell>
                                                    <TableCell>{registers.registers.find(x => x.registerName === name).device}</TableCell>
                                                    <TableCell>{registers.registers.find(x => x.registerName === name).value}</TableCell>
                                                    <TableCell>{editRegs[name]}</TableCell>
                                                    <TableCell>
                                                        <IconButton aria-label="deleteItem" onClick={() => handleDelete(name)}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow><TableCell align="center" colSpan={12}>Nie wprowadzono zmian rejestrów</TableCell></TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" className={`${classes.floatRight}`}
                                style={{ marginTop: "20px" }} onClick={() => handleClickEdit(editNames, editDevices)}>Zatwierdź</Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <Dialog scroll={"body"} fullWidth={true} maxWidth={"md"} open={openFileUpload} onClose={handleClose} aria-labelledby="file-upload">
                <DialogContent style={{ padding: "10px 25px 25px" }}>
                    <IconButton aria-label="close" onClick={handleClose} className={classes.floatRight} style={{ zIndex: "99", position: "absolute", top: "10px", right: "15px" }}>
                        <CloseIcon />
                    </IconButton>
                    <Grid container direction="row" >
                        <FileUpload client={clientRef.current} installation={installation} handleClose={handleClose} />
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default RegisterList